import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { CheckBox } from '../CheckBox';
export const CheckBoxGroup = ({ list, onToggle, isColumn = true, ...marginProps }) => (React.createElement(Container, { isColumn: isColumn }, list.map((item) => (React.createElement(CheckBox, { key: item.id, id: String(item.id), checked: item.checked, toggle: () => onToggle(item.id), ...marginProps }, item.label)))));
const Container = styled(Box) `
  display: flex;
  flex-direction: ${(p) => (p.isColumn ? 'column' : 'row')};
  gap: 16px;
`;
//# sourceMappingURL=CheckBoxGroup.js.map